<template>
  <div>
    <router-link to="/admin/users"
      ><p style="cursor: pointer; margin-bottom: 10px">
        <u>Back to all users</u>
      </p></router-link
    >
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <h1 v-bg-typography="'h1'">Add new user</h1>
    <div class="form" style="margin-top: 50px" v-if="!isLoading">
      <div>
        <bg-field class="field" label="Email" name="end">
          <bg-input v-model="email" />
        </bg-field>
      </div>
      <div>
        <bg-field label="Company" name="name">
          <bg-select
            :options="items"
            label="name"
            :value="company"
            @change="onCompanyChange"
            :clearable="true"
            :searchable="true"
          ></bg-select>
        </bg-field>
      </div>
      <div>
        <bg-field label="Role" name="email">
          <bg-select
            :options="roleOptions"
            label="text"
            :value="role"
            @change="onRoleChange"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-button
          variant="primary"
          text="Save"
          @click="saveUser"
          style="margin-bottom: 30px; margin-right: 20px"
        />
        <bg-button
          variant="secondary"
          text="Close"
          style="margin-bottom: 30px"
          @click="goBack()"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.form {
  max-width: 500px;
}
</style>

<script>
import API from "@/api";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgLoader from "@/components/bg-loader";
import BgInput from "@/components/bg-input";
import BgTypography from "@/directives/bg-typography";
import BgSelect from "@/components/bg-select";

export default {
  components: {
    BgButton,
    BgField,
    BgButton,
    BgLoader,
    BgInput,
    BgSelect,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      company: null,
      email: "",
      isLoading: false,
      items: [],
      roleOptions: [
        {
          text: "Company Admin",
          value: "company_admin",
        },
        {
          text: "Company Member",
          value: "company_member",
        },
        {
          text: "Demo user",
          value: "demo",
        },
      ],
      role: "",
    };
  },
  created() {
    this.fetchCompanies();
  },
  methods: {
    async fetchCompanies() {
      this.isLoading = true;

      if (this.$store.state.user.user.role === "admin") {
        this.roleOptions.push({
          text: "Braingineers employee",
          value: "admin",
        });
      }
      const data = await API.user.getCompanies();
      data.companies.forEach((el) => {
        this.items.push(el);
      });

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const brandA = a.name.toUpperCase();
        const brandB = b.name.toUpperCase();

        let comparison = 0;
        if (brandA > brandB) {
          comparison = 1;
        } else if (brandA < brandB) {
          comparison = -1;
        }
        return comparison;
      }
      this.items.sort(compare);
      this.isLoading = false;
    },
    goBack() {
      this.$router.push("/admin/users");
    },
    onCompanyChange(val) {
      this.company = val;
    },
    onRoleChange(role) {
      this.role = role;
    },
    async saveUser() {
      this.isLoading = true;
      let companyId = this.company.id;
      if (this.role.value === "demo") {
        companyId = 1;
      }
      const user = {
        email: this.email,
        role: this.role.value,
        company_id: this.company.id,
      };
      const res = await API.user.postUser(user);
      console.log(res);
      await this.$store.dispatch("fetchAllUsers");
      this.$router.push("/admin/users");
    },
  },
};
</script>
